<template>
  <!--  pdf 在线查看  -->
  <el-dialog
    :close-on-click-modal="false"
    width="70%"
    top="40px"
    title="查看"
    class="sp-manager__dialog"
    :visible="pdfVisible"
    :before-close="beforeCloseDialog"
    append-to-body
  >
    <div slot="title" class="dialog-header-title">
      <span class="name">查看</span>
    </div>
    <!--展示-->
    <div ref="previewEl" class="previewEl"></div>
  </el-dialog>
</template>

<script>
import pdfobject from "pdfobject";
import "jspdf-autotable";

export default {
  name: "pdfOutLine",
  props: {
    pdfVisible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    iframeSrc: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {

    };
  },
  computed: {
  },
  watch: {
    pdfData(newValue) {
      if (newValue.length) {
        this.$nextTick(() => {
          this.exportsPDF();
        });
      }
    }
  },
  methods: {
    //在线预览展示
    pdfUrlShow() {
      let that = this;
      let previewEl = that.$refs.previewEl;
      pdfobject.embed(that.iframeSrc, previewEl);
    },
    beforeCloseDialog() {
      this.$emit("pdfCLose");
    }
  }
};
</script>

<style lang="scss" scoped>
>>>.el-dialog__body{
    height: calc(100% - 50px);
    padding:0px;
    padding-left:5px;
}
.previewEl {
  width: 100%;
  height: 800px;
  line-height: 40px;
}
.pre_title {
  font-size: 20px;
  color: rgba(16, 16, 16, 100);
  text-align: center;
}
.pre_line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.pre_img {
  display: inline-flex;
  flex-direction: row;
  .pre_img_left {
  }
  .pre_img_right {
    flex: 1;
    .pre_img_item {
      width: 120px;
      height: 120px;
      margin: 10px;
    }
  }
}
.pre_footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.pre_footer_first {
  width: 200px;
}
</style>
